// Dependencies
import { createFileRoute } from "@tanstack/react-router";
import { PageShell, PageHero } from "@/components/PageShell";
import { CategoryProductGrid } from "@/components/CategoryProductGrid";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

// Images
import heroImage from "@/assets/hero-cubesat.png";
import bizupodImage from "@/assets/bizupod.png";
import bebeconfortoImage from "@/assets/bebeconforto.png";

export const Route = createFileRoute("/$lang/category/cubesat-deployer-system")({
  head: () => ({
    meta: [
      { title: i18n.t("category/cubesat-deployer-system:metaTitle", "CubeSat Deployer Systems — BIZU Space") },
      {
        name: "description",
        content: i18n.t("category/cubesat-deployer-system:metaDesc",
          "Flight-qualified, reliable deployment systems designed and tested in Brazil by BIZU Space for CubeSat satellite integration and release.",
        ),
      },
      { property: "og:title", content: i18n.t("category/cubesat-deployer-system:metaTitle", "CubeSat Deployer Systems — BIZU Space") },
      {
        property: "og:description",
        content: i18n.t("category/cubesat-deployer-system:metaOgDesc",
          "Sovereign, space-qualified CubeSat deployers (BIZU POD) engineered for reliable integration and mission deployment.",
        ),
      },
      { property: "og:url", content: "/category/cubesat-deployer-system" },
    ],
    links: [{ rel: "canonical", href: "https://bizu.space/category/cubesat-deployer-system" }],
  }),
  component: CubesatDeployerSystem,
});

function CubesatDeployerSystem() {
  const { t } = useTranslation("category/cubesat-deployer-system");

  const products = [
    {
      name: "BIZU POD",
      displayName: <span className="keep-case">BIZU POD</span>,
      link: "/products/bizupod",
      image: bizupodImage,
      buttonText: t("bizupodBtn", "Explore"),
    },
    {
      name: t("missionName", "Mission “Bebê Conforto”"),
      link: "/missions#bebe-conforto",
      image: bebeconfortoImage,
      buttonText: t("missionBtn", "Explore"),
    },
  ];

  return (
    <PageShell>
      {/* HERO SECTION */}
      <PageHero
        title={t("heroTitle", "CubeSat deployer system")}
        description={t("heroDesc",
          "Fully in-house developed and space-qualified CubeSat deployer systems, engineered to ensure safe and reliable satellite integration and deployment.",
        )}
        image={heroImage}
      />
      {/* PRODUCTS SECTION */}
      <CategoryProductGrid products={products} />
    </PageShell>
  );
}
